<template lang="html">
  <div>
    <update-topic
      mode="create"
    />
  </div>
</template>

<script>
  // import router from '../router'
  // import { MessageBox } from 'element-ui'
  import UpdateTopic from './update-topic.vue'
  // import Vue from 'vue'
  
  export default {
    components: {
      UpdateTopic
    },
    data () {
      return {
      }
    },
    computed: {},
    methods: {},
    mounted () {
    }
  }
</script>

<style lang="css" scoped>
</style>
